export const initialState = {
    timerResponseData: null,
};

const state = { ...initialState };

export default state;